import { createTheme } from '@mui/material/styles';
export const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#0073BC',
            light: '#2691CF',
        },
        secondary: {
            main: '#36823F',
            dark: '#216432',
        },
        background: {
            default: '#F7F7FB',
            paper: '#FFFFFF',
        },
    },
    shape: {
        borderRadius: 12,
    },
    typography: {
        fontFamily: [
            '"Public Sans"',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
        ].join(','),
        h4: {
            fontWeight: 700,
            letterSpacing: '-0.02em',
        },
        h5: {
            fontWeight: 700,
            letterSpacing: '-0.02em',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 8,
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
    },
});
